// import {
//   Button,
//   Flex,
//   FormControl,
//   FormLabel,
//   Input,
//   Modal,
//   ModalBody,
//   ModalCloseButton,
//   ModalContent,
//   ModalFooter,
//   ModalHeader,
//   ModalOverlay,
//   Select,
//   useToast,
//   FormErrorMessage,
// } from "@chakra-ui/react";
// import { Field, Form, Formik } from "formik";
// import React, { useMemo } from "react";
// import { useDispatch } from "react-redux";
// import * as Yup from "yup";

// interface SlotEditorModalProps {
//   isEditorOpen: boolean;
//   onEditorClose: () => void;
//   selectedRestaurant: any;
//   slotData?: any;
//   selectedTime: TimeSlot;
//   selectedDay?: string;
//   restaurantIds?: string[];
//   onSlotsUpdate: () => void;
// }

// type TimeSlot = "lunch" | "dinner";

// interface FormValues {
//   restaurantId: string;
//   type: string;
//   timing: string;
//   discount: number;
//   tableLimit: string;
// }

// const SlotEditorModal: React.FC<SlotEditorModalProps> = ({
//   isEditorOpen,
//   onEditorClose,
//   slotData,
//   selectedRestaurant,
//   selectedTime,
//   selectedDay,
//   restaurantIds,
//   onSlotsUpdate,
// }) => {
//   // console.log("selectedDay nirrrrrrrrrr", restaurantIds);
//   // console.log("selectedRestaurant nirrrrrrrrrr", selectedRestaurant);

//   const validationSchema = Yup.object().shape({
//     type: Yup.string()
//       .oneOf(["Lunch", "Dinner"], "Type must be either Lunch or Dinner")
//       .required("Slot type is required"),
//     timing: Yup.string().required("Timing is required"),
//     discount: Yup.number()
//       .typeError("Discount must be a number")
//       .min(1, "Discount must be at least greater than 0")
//       .max(100, "Discount cannot exceed 100")
//       .required("Discount is required"),
//     tableLimit: Yup.string()
//       .required("Table limit is required")
//       .test(
//         "is-number",
//         "Table limit must be a number",
//         (value) => !isNaN(Number(value))
//       )
//       .test(
//         "is-positive",
//         "Table limit must be at least 1",
//         (value) => Number(value) >= 1
//       ),
//   });
//   const dispatch = useDispatch();
//   const toast = useToast();
//   console.log("selectedTime", selectedTime);
//   console.log("restaurantIds", restaurantIds);

//   const initialValues: FormValues = useMemo(() => {
//     if (slotData) {
//       return {
//         restaurantId: slotData?.restaurantId || selectedRestaurant?._id || "",
//         type: selectedTime.charAt(0).toUpperCase() + selectedTime.slice(1),
//         timing: slotData?.time || "12:00 - 13:00",
//         discount: slotData?.discount || 0,
//         tableLimit: slotData?.totalSeats || "0",
//         tablefilled: slotData?.seatsBooked?.totalPeople || "0",

//         tableavailable:
//           slotData?.totalSeats - slotData?.seatsBooked?.totalPeople || "0",
//       };
//     }
//     return {
//       restaurantId: selectedRestaurant?._id || "",
//       type: "",
//       timing: "",
//       discount: null,
//       tableLimit: "",
//       tablefilled: "0",
//       tableavailable: "0",
//     };
//   }, [slotData, selectedRestaurant, selectedTime]);

//   const handleSubmit = async (values: FormValues, { setSubmitting }: any) => {
//     try {
//       const payload: {
//         restaurantId: any;
//         type: string;
//         time: string;
//         discount: number;
//         totalSeats: string;
//         // detail: { time: string; discount: number; totalSeats: string }[];
//         slotId?: string;
//         date: any;
//         // slotType: any;
//       } = {
//         restaurantId: selectedRestaurant,
//         type: values.type.toLowerCase(),
//         // detail: [
//         // {
//         time: values.timing,
//         discount: values.discount,
//         totalSeats: values.tableLimit,
//         date: selectedDay,
//         // slotType: selectedTime,
//         //   },
//         // ],
//       };

//       if (slotData?.slotId) {
//         payload.slotId = slotData.slotId;
//       }
//       // console.log("slottttttt", slotData);

//       if (slotData?.slotId) {
//         await dispatch({
//           type: "REQUEST_UPDATE_MASTER_SLOTS",
//           data: {
//             payload,
//             // _id: selectedRestaurant,
//           },
//           onSuccess: () => {
//             dispatch({ type: "REQUEST_MASTER_SLOTS" });

//             onSlotsUpdate();
//             toast({
//               title: "Success",
//               description: "Slots updated successfully",
//               status: "success",
//               duration: 3000,
//               isClosable: true,
//               position: "top-right",
//             });
//             onEditorClose();
//           },
//         });
//       } else {
//         await dispatch({
//           type: "REQUEST_CREATE_MASTER_SLOTS",
//           payload,
//           onSuccess: () => {
//             dispatch({ type: "REQUEST_MASTER_SLOTS" });

//             onSlotsUpdate();
//             toast({
//               title: "Success",
//               description: "Slots created successfully",
//               status: "success",
//               duration: 3000,
//               isClosable: true,
//               position: "top-right",
//             });
//             onEditorClose();
//           },
//         });
//       }
//     } catch (error) {
//       toast({
//         title: "Error",
//         description: "An error occurred while saving slots data",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//         position: "top-right",
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Modal isOpen={isEditorOpen} onClose={onEditorClose} size="xl" isCentered>
//       <ModalOverlay />
//       <ModalContent>
//         <ModalHeader
//           bg="#FDEDEC"
//           borderBottom={"1px solid #E0E0E0"}
//           borderTopLeftRadius={8}
//           borderTopRightRadius={8}
//         >
//           {slotData ? "Update" : "Add"} Slot
//         </ModalHeader>
//         <ModalCloseButton />
//         <Formik
//           initialValues={initialValues}
//           validationSchema={validationSchema}
//           onSubmit={handleSubmit}
//           enableReinitialize
//         >
//           {({ isSubmitting, errors, touched, values }) => (
//             <Form
//               style={{
//                 height: "100%",
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               <ModalBody pb={"16px !important"}>
//                 <Flex gap={4} alignItems="flex-start">
//                   <FormControl isInvalid={!!errors.timing && touched.timing}>
//                     <FormLabel>Slot Timing</FormLabel>
//                     <Field as={Select} name="timing" value={values.timing}>
//                       {Array.from({ length: 24 }).map((_, i) => (
//                         <option
//                           key={i}
//                           value={`${i.toString().padStart(2, "0")}:00-${(i + 1)
//                             .toString()
//                             .padStart(2, "0")}:00`}
//                         >
//                           {`${i.toString().padStart(2, "0")}:00-${(i + 1)
//                             .toString()
//                             .padStart(2, "0")}:00`}
//                         </option>
//                       ))}
//                     </Field>
//                     <FormErrorMessage>{errors.timing}</FormErrorMessage>
//                   </FormControl>

//                   <FormControl isInvalid={!!errors.type && touched.type}>
//                     <FormLabel>Type</FormLabel>
//                     <Field
//                       as={Select}
//                       name="type"
//                       disabled={!!slotData}
//                       value={values.type}
//                     >
//                       <option value="">Select Type</option>
//                       <option value="Lunch">Lunch</option>
//                       <option value="Dinner">Dinner</option>
//                     </Field>
//                     <FormErrorMessage>{errors.type}</FormErrorMessage>
//                   </FormControl>
//                 </Flex>
//                 <Flex gap={4} alignItems="flex-start" mt={4}>
//                   <FormControl
//                     isInvalid={!!errors.discount && touched.discount}
//                   >
//                     <FormLabel>Discount</FormLabel>
//                     <Field
//                       as={Input}
//                       name="discount"
//                       type="number"
//                       placeholder="Discount %"
//                       values={values.discount}
//                     />
//                     <FormErrorMessage>{errors.discount}</FormErrorMessage>
//                   </FormControl>

//                   <FormControl
//                     isInvalid={!!errors.tableLimit && touched.tableLimit}
//                   >
//                     <FormLabel>Total table limit</FormLabel>
//                     <Field
//                       as={Input}
//                       name="tableLimit"
//                       placeholder="Total tables"
//                       values={values.tableLimit}
//                     />
//                     <FormErrorMessage>{errors.tableLimit}</FormErrorMessage>
//                   </FormControl>
//                 </Flex>
//                 {slotData?.slotId && (
//                   <Flex gap={4} alignItems="flex-start" mt={4}>
//                     <FormControl>
//                       <FormLabel>Total table filled</FormLabel>
//                       <Field
//                         as={Input}
//                         name="tablefilled"
//                         type="number"
//                         readOnly
//                         _hover={{ outline: "none" }}
//                         disabled
//                       />
//                     </FormControl>

//                     <FormControl>
//                       <FormLabel>Table available</FormLabel>
//                       <Field
//                         as={Input}
//                         name="tableavailable"
//                         readOnly
//                         disabled
//                       />
//                     </FormControl>
//                   </Flex>
//                 )}
//               </ModalBody>

//               <ModalFooter>
//                 <Button
//                   variant="outline"
//                   mr={3}
//                   border="1px solid #EEE"
//                   borderRadius="6px"
//                   color="#424242"
//                   fontSize={"sm"}
//                   onClick={onEditorClose}
//                   type="button"
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   background="#E24441"
//                   fontSize={"sm"}
//                   color="#fff"
//                   type="submit"
//                   _hover={{ background: "#E24441" }}
//                   isLoading={isSubmitting}
//                 >
//                   {slotData ? "Update" : "Add"} Slot
//                 </Button>
//               </ModalFooter>
//             </Form>
//           )}
//         </Formik>
//       </ModalContent>
//     </Modal>
//   );
// };

// export default SlotEditorModal;

import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useToast,
  FormErrorMessage,
  Text,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";

interface SlotEditorModalProps {
  isEditorOpen: boolean;
  onEditorClose: () => void;
  selectedRestaurant: any;
  slotData?: any;
  selectedTime: TimeSlot;
  selectedDay?: string;
  restaurantIds?: string[];
  onSlotsUpdate: () => void;
}

type TimeSlot = "lunch" | "dinner";

interface FormValues {
  restaurantId: string;
  type: string;
  startHour: string;
  startMinute: string;
  endHour: string;
  endMinute: string;
  discount: number;
  tableLimit: string;
}

const SlotEditorModal: React.FC<SlotEditorModalProps> = ({
  isEditorOpen,
  onEditorClose,
  slotData,
  selectedRestaurant,
  selectedTime,
  selectedDay,
  restaurantIds,
  onSlotsUpdate,
}) => {
  // Generate hours array (0-23)
  const hours = Array.from({ length: 24 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );

  // Generate minutes array (0-59)
  const minutes = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  // Function to parse time string like "12:00 - 13:00" or "12:00-13:00"
  const parseTimeString = (timeString: string) => {
    if (!timeString)
      return { startHour: "", startMinute: "", endHour: "", endMinute: "" };

    const parts = timeString.split(/\s*-\s*/);
    if (parts.length !== 2)
      return { startHour: "", startMinute: "", endHour: "", endMinute: "" };

    const [startTime, endTime] = parts;
    const [startHour, startMinute] = startTime.split(":");
    const [endHour, endMinute] = endTime.split(":");

    return {
      startHour: startHour || "",
      startMinute: startMinute || "",
      endHour: endHour || "",
      endMinute: endMinute || "",
    };
  };

  // Function to combine time fields into string format
  const combineTimeFields = (
    startHour: string,
    startMinute: string,
    endHour: string,
    endMinute: string
  ) => {
    if (!startHour || !startMinute || !endHour || !endMinute) return "";
    return `${startHour}:${startMinute}-${endHour}:${endMinute}`;
  };

  const validationSchema = Yup.object().shape({
    type: Yup.string()
      .oneOf(["Lunch", "Dinner"], "Type must be either Lunch or Dinner")
      .required("Slot type is required"),
    startHour: Yup.string().required("Start hour is required"),
    startMinute: Yup.string().required("Start minute is required"),
    endHour: Yup.string().required("End hour is required"),
    endMinute: Yup.string().required("End minute is required"),
    discount: Yup.number()
      .typeError("Discount must be a number")
      .min(1, "Discount must be at least greater than 0")
      .max(100, "Discount cannot exceed 100")
      .required("Discount is required"),
    tableLimit: Yup.string()
      .required("Table limit is required")
      .test(
        "is-number",
        "Table limit must be a number",
        (value) => !isNaN(Number(value))
      )
      .test(
        "is-positive",
        "Table limit must be at least 1",
        (value) => Number(value) >= 1
      ),
  });

  const dispatch = useDispatch();
  const toast = useToast();
  console.log("selectedTime", selectedTime);
  console.log("restaurantIds", restaurantIds);

  const initialValues: FormValues = useMemo(() => {
    if (slotData) {
      const parsedTime = parseTimeString(slotData?.time || "12:00 - 13:00");
      return {
        restaurantId: slotData?.restaurantId || selectedRestaurant?._id || "",
        type: selectedTime.charAt(0).toUpperCase() + selectedTime.slice(1),
        startHour: parsedTime.startHour,
        startMinute: parsedTime.startMinute,
        endHour: parsedTime.endHour,
        endMinute: parsedTime.endMinute,
        discount: slotData?.discount || 0,
        tableLimit: slotData?.totalSeats || "0",
        tablefilled: slotData?.seatsBooked?.totalPeople || "0",
        tableavailable:
          slotData?.totalSeats - slotData?.seatsBooked?.totalPeople || "0",
      };
    }
    return {
      restaurantId: selectedRestaurant?._id || "",
      type: "",
      startHour: "",
      startMinute: "",
      endHour: "",
      endMinute: "",
      discount: null,
      tableLimit: "",
      tablefilled: "0",
      tableavailable: "0",
    };
  }, [slotData, selectedRestaurant, selectedTime]);

  const handleSubmit = async (values: FormValues, { setSubmitting }: any) => {
    try {
      // Combine time fields into the required format
      const combinedTime = combineTimeFields(
        values.startHour,
        values.startMinute,
        values.endHour,
        values.endMinute
      );

      const payload: {
        restaurantId: any;
        type: string;
        time: string;
        startTime: string;
        endTime: string;
        discount: number;
        totalSeats: string;
        slotId?: string;
        date: any;
      } = {
        restaurantId: selectedRestaurant,
        type: values.type.toLowerCase(),
        time: combinedTime,
        startTime: combinedTime.split("-")[0],
        endTime: combinedTime.split("-")[1],
        discount: values.discount,
        totalSeats: values.tableLimit,
        date: selectedDay,
      };

      if (slotData?.slotId) {
        payload.slotId = slotData.slotId;
      }

      if (slotData?.slotId) {
        await dispatch({
          type: "REQUEST_UPDATE_MASTER_SLOTS",
          data: {
            payload,
          },
          onSuccess: () => {
            dispatch({ type: "REQUEST_MASTER_SLOTS" });
            onSlotsUpdate();
            toast({
              title: "Success",
              description: "Slots updated successfully",
              status: "success",
              duration: 3000,
              isClosable: true,
              position: "top-right",
            });
            onEditorClose();
          },
        });
      } else {
        await dispatch({
          type: "REQUEST_CREATE_MASTER_SLOTS",
          payload,
          onSuccess: () => {
            dispatch({ type: "REQUEST_MASTER_SLOTS" });
            onSlotsUpdate();
            toast({
              title: "Success",
              description: "Slots created successfully",
              status: "success",
              duration: 3000,
              isClosable: true,
              position: "top-right",
            });
            onEditorClose();
          },
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "An error occurred while saving slots data",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isEditorOpen} onClose={onEditorClose} size="xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          bg="#FDEDEC"
          borderBottom={"1px solid #E0E0E0"}
          borderTopLeftRadius={8}
          borderTopRightRadius={8}
        >
          {slotData ? "Update" : "Add"} Slot
        </ModalHeader>
        <ModalCloseButton />
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isSubmitting, errors, touched, values }) => (
            <Form
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <ModalBody pb={"16px !important"}>
                {/* Time Selection Section */}
                <FormControl>
                  <FormLabel>Slot Timing</FormLabel>
                  <Flex
                    gap={4}
                    alignItems="center"
                    flexWrap="wrap"
                    justifyContent={"flex-start"}
                    // gap={4}
                  >
                    {/* Start Time */}
                    <Flex gap={1} alignItems="center">
                      <Text
                        fontSize="md"
                        color="gray.700"
                        marginBottom={0}
                        fontWeight={600}
                        marginRight={1}
                      >
                        From:
                      </Text>
                      <FormControl
                        isInvalid={!!errors.startHour && touched.startHour}
                        minWidth="70px"
                      >
                        <Field
                          as={Select}
                          name="startHour"
                          size="sm"
                          placeholder="HH"
                        >
                          {hours.map((hour) => (
                            <option key={hour} value={hour}>
                              {hour}
                            </option>
                          ))}
                        </Field>
                      </FormControl>
                      <Text marginBottom={0}>:</Text>
                      <FormControl
                        isInvalid={!!errors.startMinute && touched.startMinute}
                        minWidth="70px"
                      >
                        <Field
                          as={Select}
                          name="startMinute"
                          size="sm"
                          placeholder="MM"
                        >
                          {minutes.map((minute) => (
                            <option key={minute} value={minute}>
                              {minute}
                            </option>
                          ))}
                        </Field>
                      </FormControl>
                    </Flex>

                    {/* End Time */}
                    <Flex gap={1} alignItems="center">
                      <Text
                        fontSize="md"
                        color="gray.700"
                        marginBottom={0}
                        fontWeight={600}
                        marginRight={1}
                      >
                        To:
                      </Text>
                      <FormControl
                        isInvalid={!!errors.endHour && touched.endHour}
                        minWidth="70px"
                      >
                        <Field
                          as={Select}
                          name="endHour"
                          size="sm"
                          placeholder="HH"
                        >
                          {hours.map((hour) => (
                            <option key={hour} value={hour}>
                              {hour}
                            </option>
                          ))}
                        </Field>
                      </FormControl>
                      <Text marginBottom={0}>:</Text>
                      <FormControl
                        isInvalid={!!errors.endMinute && touched.endMinute}
                        minWidth="70px"
                      >
                        <Field
                          as={Select}
                          name="endMinute"
                          size="sm"
                          placeholder="MM"
                        >
                          {minutes.map((minute) => (
                            <option key={minute} value={minute}>
                              {minute}
                            </option>
                          ))}
                        </Field>
                      </FormControl>
                    </Flex>
                  </Flex>

                  {/* Error Messages for Time Fields */}
                  {((errors.startHour && touched.startHour) ||
                    (errors.startMinute && touched.startMinute) ||
                    (errors.endHour && touched.endHour) ||
                    (errors.endMinute && touched.endMinute)) && (
                    <FormErrorMessage>
                      {errors.startHour ||
                        errors.startMinute ||
                        errors.endHour ||
                        errors.endMinute}
                    </FormErrorMessage>
                  )}
                </FormControl>

                {/* Type Selection */}
                <FormControl isInvalid={!!errors.type && touched.type} mt={4}>
                  <FormLabel>Type</FormLabel>
                  <Field
                    as={Select}
                    name="type"
                    disabled={!!slotData}
                    value={values.type}
                  >
                    <option value="">Select Type</option>
                    <option value="Lunch">Lunch</option>
                    <option value="Dinner">Dinner</option>
                  </Field>
                  <FormErrorMessage>{errors.type}</FormErrorMessage>
                </FormControl>

                {/* Discount and Table Limit */}
                <Flex gap={4} alignItems="flex-start" mt={4}>
                  <FormControl
                    isInvalid={!!errors.discount && touched.discount}
                  >
                    <FormLabel>Discount</FormLabel>
                    <Field
                      as={Input}
                      name="discount"
                      type="number"
                      placeholder="Discount %"
                      value={values.discount}
                    />
                    <FormErrorMessage>{errors.discount}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    isInvalid={!!errors.tableLimit && touched.tableLimit}
                  >
                    <FormLabel>Total table limit</FormLabel>
                    <Field
                      as={Input}
                      name="tableLimit"
                      placeholder="Total tables"
                      value={values.tableLimit}
                    />
                    <FormErrorMessage>{errors.tableLimit}</FormErrorMessage>
                  </FormControl>
                </Flex>

                {/* Table Status (for existing slots) */}
                {slotData?.slotId && (
                  <Flex gap={4} alignItems="flex-start" mt={4}>
                    <FormControl>
                      <FormLabel>Total table filled</FormLabel>
                      <Field
                        as={Input}
                        name="tablefilled"
                        type="number"
                        readOnly
                        _hover={{ outline: "none" }}
                        disabled
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel>Table available</FormLabel>
                      <Field
                        as={Input}
                        name="tableavailable"
                        readOnly
                        disabled
                      />
                    </FormControl>
                  </Flex>
                )}
              </ModalBody>

              <ModalFooter>
                <Button
                  variant="outline"
                  mr={3}
                  border="1px solid #EEE"
                  borderRadius="6px"
                  color="#424242"
                  fontSize={"sm"}
                  onClick={onEditorClose}
                  type="button"
                >
                  Cancel
                </Button>
                <Button
                  background="#E24441"
                  fontSize={"sm"}
                  color="#fff"
                  type="submit"
                  _hover={{ background: "#E24441" }}
                  isLoading={isSubmitting}
                >
                  {slotData ? "Update" : "Add"} Slot
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );
};

export default SlotEditorModal;
